import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';

import { staffList, classList } from '../../api/Calendar';

interface Istaff {
  id: string;
  name: string;
  user_id: string;
  user_school_img: string | any;
}
interface Iclass {
  class_id: string;
  class_name: string;
  grade_id: string;
  grade_name: string;
  grade_type: string;
  permission: string;
  year_id: string;
  year_name: string;
  year_status: string;
}
type commonState = {
  classList: Array<Iclass>;
  staffList: Array<Istaff>;
  isLoading: boolean;
  error: boolean;
};

const initialState: commonState = {
  classList: [],
  staffList: [],
  isLoading: false,
  error: false
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // 获取教职工列表成功
    getStaffListSuccess(state, action) {
      state.staffList = action.payload;
    },
    // 获取班级列表成功
    getClassListSuccess(state, action) {
      state.classList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// action
// 获取教职工列表
export function getStaffList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await staffList(params);
      dispatch(slice.actions.getStaffListSuccess(res));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取班级列表
export function getClassList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await classList(params);
      dispatch(slice.actions.getClassListSuccess(res.rows));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
